export default __webpack_public_path__ + "static/impact-hero-image-2-1338b39b5cc4449ce87fa158b0ea4dc1.jpg";